import React from 'react'
import Alert from '@/components/ui/Alert'
import Button from '@/components/ui/Buttons/Button'
import { ReactComponent as WarningIcon } from '@/assets/icons/warning.svg'
import { TrialStatus, useTrial } from '@/components/TrialSection/TrialSection.hooks'
import { formatDate } from '@/utils/string'
import { useAuth } from '@/features/auth'

export type TrialSectionProps = {
  className?: string
}
const TrialSection = ({ className }: TrialSectionProps) => {
  const [endDate, status] = useTrial()
  const auth = useAuth()

  if (status === TrialStatus.Valid) return null

  if (status === TrialStatus.ExpireSoon)
    return (
      <div className={className}>
        <Alert
          variant={'soft'}
          color={'warning'}
          startAdornment={<WarningIcon />}
          endAdornment={
            <Button
              color={'warning'}
              variant={'soft'}
              onClick={() => auth.openInKnots.mutate()}
              disabled={auth.openInKnots.isPending}
            >
              Profile
            </Button>
          }
        >
          Your trial for Knots Studio will expire on {formatDate(endDate)}. Please, fill billing details for the Knots
          Studio in your Knots profile to keep using your routes
        </Alert>
      </div>
    )

  return (
    <div className={className}>
      <Alert
        variant={'soft'}
        color={'danger'}
        startAdornment={<WarningIcon />}
        endAdornment={
          <Button
            color={'danger'}
            variant={'soft'}
            onClick={() => auth.openInKnots.mutate()}
            disabled={auth.openInKnots.isPending}
          >
            Profile
          </Button>
        }
      >
        Your trial for Knots Studio has ended. Please, enable the Knots Studio module in your Knots profile to continue
        using your routes
      </Alert>
    </div>
  )
}

export default TrialSection
